<template>
    <div class="login-container" v-show="false">
        <div class="form-box">
            <p class="title">
                登录
            </p>
            <el-form :model="info" ref="login">
                <el-form-item prop="username">
                    <el-input placeholder="请输入手机号" v-model="info.account"></el-input>
                </el-form-item>
                 <el-form-item prop="password">
                   <el-input type="password" placeholder="请输入密码" v-model="info.passport"></el-input>
                </el-form-item>
                
                <el-form-item class="login">
                    <el-button @click="login" v-loading="subStatus">立即登录</el-button>
                </el-form-item>
            </el-form>
            <div class="bottom-box">
                <router-link to="find">忘记密码</router-link>
                <router-link to="register">免费注册</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import {apiLogin,apiGetUserInfo,apiSSO,apiSSOAuth} from '../../plugins/apis'
import "../../assets/css/login_new.css";
export default { 
  data () {
    return {
        info:{
            account:'',
            passport:'',
        },
        origin:[
            {
                value:'高校方向班',
                label:'高校方向班'
            },
            {
                value:'网络',
                label:'网络'
            },
            // {
            //     value:'智联招聘',
            //     label:'智联招聘'
            // }
        ],
        subStatus:false,
        rounds:[]
    }
  }, 
  async mounted(){
        console.log('login new');
      await this.checkLogin()
  },
  methods: {  
    async checkLogin(){
        if(window.localStorage.cima_registration_token){
            let res = await apiGetUserInfo()
            if(res.code === 200){
                this.$router.push('form')
            }
        }else{
            let _data = {
                // redirect_uri:window.location.href
                redirect_uri:'https://gbc.cncima.com/report/login'
            }
            let code = this.$route.query.code;
            if(Array.isArray(code)){
                code = code.pop()
            }else{
                code = code || ''
            }
            const channel = localStorage.getItem('channel')
            if(channel) {
                _data.channel = channel
            }
            if(code){
                _data.redirect_uri = 'https://gbc.cncima.com/report/login'
                // _data.redirect_uri = window.localStorage.sso_redirect_href || window.location.href
                _data.code = code
                let e = await apiSSOAuth(_data)
                if(e.code === 200){
                    window.localStorage.setItem('cima_registration_token',e.data.token)
                    this.$NProgress.done()
                    this.$router.push('/form')
                }else if(e.message === 'code is invalid'){
                    window.localStorage.setItem('sso_redirect_href',_data.redirect_uri)
                    let e = await apiSSO(_data )
                    if(e.code === 200){
                        window.location.href = e.data
                    }
                }
            }else{
                window.localStorage.setItem('sso_redirect_href',_data.redirect_uri)
                let e = await apiSSO(_data )
                if(e.code === 200){
                    window.location.href = e.data
                }
            }
            
        }
    },
    async login(){
        if(!this.info.account){
            this.$message.error("请输入手机号")
            return
        }
        if(!this.info.passport){
            this.$message.error("请输入密码")
            return
        }
        this.subStatus = true
        let _data = this.info
        let res = await apiLogin(_data)
        this.$NProgress.inc()
        if(res.code === 200){
            if(res.data.flag === 2){
                window.localStorage.setItem('cima_registration_token',res.data.token)
                this.$NProgress.done()
                this.$router.push('/form')
                
            }else{
                this.$message.error('此账号不存在')
                this.$NProgress.done()
            }
        }else{
            this.$message.error(res.message)
            this.$NProgress.done()
        }
        this.subStatus = false
        
    }
  }
}
</script>

<style>

</style>

